import useUserStore from '@/stores/user.store';

// Steam OpenID `checkid_setup` query used by the authv2 login flow. The
// `$domain.com` placeholder is swapped for the live site domain at call time
// (see `openAuthV2`).
const OPENID_QUERY =
    'openid.claimed_id=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select' +
    '&openid.identity=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select' +
    '&openid.mode=checkid_setup' +
    '&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0' +
    '&openid.realm=https%3A%2F%2F$domain.com' +
    '&openid.return_to=https%3A%2F%2F$domain.com%2Fapi%2Fauth%2Fcallback-steam';

// Site domain for the OpenID realm/return_to. `sitename` ("rustyjungle") gets
// `.com` appended when it carries no dot; an explicit domain is used as-is.
const authDomain = () => {
    const sitename = (useUserStore.getState().sitename || '').toLowerCase().trim();
    if (!sitename) return '';
    return sitename.includes('.') ? sitename : `${sitename}.com`;
};

export const authUrl = () =>
    useUserStore.getState().authv2 ? '/api/authv2/' : '/api/auth';

export const goAuthClass = () => (useUserStore.getState().authv2 ? 'goAuth' : '');

// Full-page navigation (not a popup) to the backend authv2 login endpoint.
export const openAuthV2 = () => {
    const query = OPENID_QUERY.replace(/\$domain\.com/g, authDomain());
    window.location.href = `/api/authv2/login?${query}`;
};

export const login = () => {
    if (useUserStore.getState().authv2) {
        openAuthV2();
    } else {
        window.location.href = '/api/auth';
    }
};

export const logout = () => (window.location.href = '/api/auth/logout');
